/* eslint-disable no-console */
import Backbone from "custom/backbone-bundle";
import $ from "jquery";

import { getApiUrl } from "../utils/get-api-url";
import { hasTaxonomy } from "../utils/taxonomy";
import { topic } from "../globals/topic";
import { unit } from "../globals/unit";
import { lesson } from "../globals/lesson";
import { task } from "../globals/task";
import { getCsrfToken } from "../utils/csrf";

const debug = getDebug();
if (debug) {
  console.group("Analytics Service: created");
  console.groupEnd();
}

export function track(event) {
  if (!["error", "fork", "new", "lesson", "navigation"].includes(event.type)) {
    return;
  }

  const pageType =
    event.type === "error"
      ? "Error page"
      : event.type === "fork"
      ? "Fork app"
      : hasTaxonomy(task, "use-type.user-generated")
      ? "User app"
      : event.type === "new"
      ? "New app"
      : hasTaxonomy(task, "use-type.free-code")
      ? "Free code"
      : event.type === "lesson"
      ? "Lesson"
      : "Task";
  const stepName = task.get("type") === "splash" ? "Introduction" : null;
  const stepIndex =
    lesson
      .get("tasks")
      .filter(step => step.get("type") !== "splash")
      .indexOf(task) + 1;

  // Collect together all the data for the page view
  const data = {
    // Hard-code app route here is fine as it is only for analytics, where consistency > accuracy.
    page: "/app/" + Backbone.history.getFragment(),
    topic: topic.get("name"),
    unit: unit.get("name"),
    lesson: lesson.get("name"),
    pageName:
      pageType === "Fork app" || pageType === "User app"
        ? task.get("name")
        : pageType === "Error page" ||
          pageType === "New app" ||
          pageType === "Free code"
        ? pageType
        : pageType === "Lesson"
        ? lesson.get("name")
        : `${lesson.get("name")} - ${stepName || stepIndex}`,
    pageType,
    eventType: event.type,
    errorData: event.errorData,
  };
  if (debug) {
    console.group("Analytics Service: send page view");
    logObjectProperties(data);
    console.groupEnd();
  }

  // Send to back-end for processing
  sendEvent(data);
}

function getDebug() {
  try {
    return !!document.cookie
      .split(";")
      .find(cookie => cookie.trim() === "DEBUG_ANALYTICS=1");
  } catch (error) {
    // eslint-disable-next-line no-empty
  }
  return false;
}

function logObjectProperties(data) {
  const padding = new Array(20).join(" ");
  for (const key in data) {
    if (Object.prototype.hasOwnProperty.call(data, key)) {
      console.log(`${(key + padding).substr(0, padding.length)}  ${data[key]}`);
    }
  }
}

function sendEvent(data) {
  const csrfToken = getCsrfToken();
  $.ajax({
    method: "post",
    url: getApiUrl("tracking/event"),
    headers: {
      "X-CSRF-Token": csrfToken,
    },
    contentType: "application/json",
    data: JSON.stringify(data),
  });
}
